import { cache } from 'react';
import { Locale } from '@headless-workspace/config';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { PromoStandardTextRepositoryType } from '../../../../../DI/dependencyInjection';
import { CommonDI } from '../../../../../DI/index';

export const getPromoStandardText = cache(async (locale: Locale) => {
    const result = await CommonDI.get(PromoStandardTextRepositoryType).getPromoStandardText(locale);
    return unwrapResultSuccess(result);
});
